import { render } from "./App.vue?vue&type=template&id=4ffb2228"
const script = {}

import exportComponent from "/Users/amir/Desktop/movie-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__